import { render, staticRenderFns } from "./HomeWebshop.vue?vue&type=template&id=6ca47ea3"
import script from "./HomeWebshop.vue?vue&type=script&lang=js"
export * from "./HomeWebshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports